/**
 * System Service
 * Handles system-level operations like URL registration
 */

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

class SystemAPI {
  /**
   * Register the current frontend URL with the backend
   * This allows the backend to dynamically redirect to the correct port
   */
  static async registerFrontendUrl() {
    try {
      // Get the current window location
      const currentUrl = `${window.location.protocol}//${window.location.host}`;
      
      console.log(`🔧 SystemAPI: Registering frontend URL: ${currentUrl}`);
      
      const response = await fetch(`${API_BASE_URL}/api/auth/register-frontend-url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url: currentUrl }),
        credentials: 'include'
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to register frontend URL');
      }

      console.log(`✅ SystemAPI: Frontend URL registered successfully: ${currentUrl}`);
      return data;
      
    } catch (error) {
      console.error('❌ SystemAPI.registerFrontendUrl error:', error);
      // Don't throw - this is not critical to app functionality
      return { success: false, error: error.message };
    }
  }

  /**
   * Initialize system services on app startup
   */
  static async initialize() {
    // Frontend URL is configured via FRONTEND_URL env var on the worker
    // No dynamic registration needed
    return { success: true };
  }
}

export default SystemAPI;